<script setup lang="ts">
import { useColorMode } from "@vueuse/core";
import { Button } from "@/components/ui/button";
import { Moon, Sun } from "lucide-vue-next";
import { watch } from "vue";

// 恢复useColorMode功能，设置默认为light主题
// SSR时不使用localStorage
const mode = useColorMode({
  attribute: 'class',
  modes: {
    dark: 'dark',
    light: '',
  },
  storageKey: 'vueuse-color-scheme',
  storage: import.meta.env.SSR ? undefined : localStorage,
  initialValue: 'light', // 确保默认值为light
});

// 监听主题变化（减少调试信息）
watch(mode, (newMode) => {
  console.log('🎨 主题切换到:', newMode);
}, { immediate: true });

// 恢复主题切换功能
const toggleTheme = () => {
  const newMode = mode.value === 'dark' ? 'light' : 'dark';
  console.log('🔄 主题切换:', mode.value, '→', newMode);
  mode.value = newMode;
};
</script>

<template>
  <Button @click="toggleTheme" size="sm" variant="ghost" class="w-full justify-start">
    <div v-if="mode === 'light'" class="flex gap-2">
      <Moon class="size-5" />
      <span class="block lg:hidden"> Dark </span>
    </div>

    <div v-else class="flex gap-2">
      <Sun class="size-5" />
      <span class="block lg:hidden">Light</span>
    </div>

    <span class="sr-only">Toggle theme</span>
  </Button>
</template>
